
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign/itdr",
      function () {
        return require("private-next-pages/sign/itdr.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign/itdr"])
      });
    }
  